import { api } from '../api';
import { useApi } from '../lib/useApi';
import Drawer from '../components/Drawer';
import { ErrorState, Loading } from '../components/ui';
import { ago, fmtDate, n0 } from '../lib/format';
import { useAuth } from '../components/AuthProvider';

export default function UserDrawer({ id, onClose }) {
  return <Drawer open={!!id} onClose={onClose}>{id ? <Body id={id} onClose={onClose} /> : null}</Drawer>;
}

function Body({ id, onClose }) {
  const { canEdit } = useAuth();
  const { data: u, loading, error, reload } = useApi(() => api.user(id), [id]);

  if (loading) return <div className="dr-body"><Loading what="карточку" /></div>;
  if (error) return <div className="dr-body"><ErrorState error={error} onRetry={reload} /></div>;

  return (
    <>
      <div className="dr-head">
        <button className="close" onClick={onClose} aria-label="закрыть">✕</button>
        <h2>{u.firstName} {u.lastName}</h2>
        <div className="muted" style={{ fontSize: 13 }}>
          {u.email} {u.blocked ? <span className="badge b-blocked">заблокирован</span> : null}
        </div>
      </div>
      <div className="dr-body">
        <dl className="kv">
          <dt>пространства</dt>
          <dd>
            {(u.organizations || []).length
              ? u.organizations.map((r) => (
                  <div key={r.id}>
                    {r.title} — {r.role === 'OWNER' ? 'владелец' : 'редактор'}
                    {r.status === 'PENDING' ? ' (приглашение не принято)' : ''}
                  </div>
                ))
              : <span className="muted">не состоит ни в одном</span>}
          </dd>
          <dt>зарегистрирован</dt><dd>{fmtDate(u.createdAt)}</dd>
          <dt>последняя активность</dt>
          <dd>
            {u.lastActivityAt
              ? <>{fmtDate(u.lastActivityAt)} <span className="muted">({ago(u.lastActivityAt)})</span></>
              : <span className="muted">комментариев не оставлял</span>}
          </dd>
          <dt>комментариев</dt><dd className="mono">{n0(u.comments)}</dd>
          <dt>триал</dt><dd>{u.trialUsedAt ? `использован ${fmtDate(u.trialUsedAt)}` : 'ещё доступен'}</dd>
        </dl>

        {canEdit ? (
          <div>
            <h3 className="dr-h">действия</h3>
            <div className="act">
              <button className="btn">{u.trialUsedAt ? 'сбросить триал' : 'выдать триал'}</button>
              <button className="btn danger">{u.blocked ? 'разблокировать' : 'заблокировать'}</button>
            </div>
            <div className="note" style={{ marginTop: 12 }}>
              Блокировка требует причины — она видна пользователю и остаётся в журнале.
            </div>
          </div>
        ) : (
          <div className="note">У вас доступ только на чтение — действия скрыты.</div>
        )}
      </div>
    </>
  );
}
